import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Loader2, Lock } from "lucide-react";

function LoadingScreen() {
  return (
    <div className="min-h-[calc(100vh-4rem)] grid place-items-center px-6" data-testid="auth-loading">
      <div className="flex flex-col items-center gap-3 text-zinc-400">
        <Loader2 className="w-6 h-6 animate-spin text-emerald-400" />
        <div className="text-sm">Vérification de la session…</div>
      </div>
    </div>
  );
}

export function RequireAuth({ children }) {
  const { user, checked } = useAuth();
  const location = useLocation();
  if (!checked) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  return children;
}

export function RequireAdmin({ children }) {
  const { user, checked } = useAuth();
  const location = useLocation();
  if (!checked) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (user.role !== "admin") {
    return (
      <div className="min-h-[calc(100vh-4rem)] grid place-items-center px-6" data-testid="admin-forbidden">
        <div className="max-w-md text-center p-8 rounded-lg border border-white/5 bg-card">
          <span className="inline-flex w-12 h-12 rounded-md bg-rose-500/15 border border-rose-500/30 items-center justify-center mb-4">
            <Lock className="w-5 h-5 text-rose-400" />
          </span>
          <h2 className="font-display font-bold text-2xl">Accès réservé</h2>
          <p className="mt-2 text-sm text-zinc-400">
            Cette page est réservée aux administrateurs du portefeuille.
          </p>
        </div>
      </div>
    );
  }
  return children;
}
